module.exports = __webpack_public_path__ + "img/94028.59da95e7.svg";